module.exports = __webpack_public_path__ + "img/podoarttour_main_02.3dd32c94.jpg";